<template functional>
  <li class="process-list-item__wrapper">
    <div class="list-item__img">
      <img v-if="props.oauth" v-pic.oauth.avatar="props.avatar" alt="avatar" />
      <img v-else v-pic.avatar="props.avatar" alt="avatar" />
    </div>
    <div class="list-item__des">
      <h4>
        {{ props.name }}
        <span>{{ props.time }}</span>
      </h4>
      <p>{{ props.des }}</p>
      <div class="img-list">
        <template v-if="props.imgs">
          <el-image v-for="(i,ii) in $options.formatterImgs(props.imgs)" :key="ii" :src="i" :preview-src-list="$options.formatterImgs(props.imgs)" />
        </template>
      </div>
    </div>
  </li>
</template>

<script>
import { echoAddress } from '@/config/config';

export default {
  name: 'processItem',
  props: {
    name: String,
    time: String,
    avatar: String,
    imgs: Array,
    des: String,
    oauth: Boolean
  },
  formatterImgs(imgs) {
    return imgs?.map(m => echoAddress + m.location) || [];
  }
};
</script>

<style lang="scss">
.process-list-item__wrapper {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid #ececec;
  font-size: 14px;
  .list-item__img {
    img {
      object-fit: cover;
      height: 56px;
      width: 56px;
      font-size: 0;
      vertical-align: bottom;
      border-radius: 50%;
    }
  }
  .list-item__des {
    flex: 1;
    margin-left: 12px;
    color: #828892;
    & > h4 {
      font-weight: 400;
      color: #161c26;
      line-height: 20px;
    }
    & > span {
      color: #828892;
      font-weight: 400;
      float: right;
      font-size: 12px;
    }
    & > p {
      margin-top: 9px;
      line-height: 20px;
    }
  }
  .img-list {
    .el-image {
      height: 64px;
      width: 64px;
      border-radius: 4px;
      margin-right: 6px;
      margin-top: 6px;
      .el-icon-circle-close {
        font-size: 40px;
      }
    }
  }
}
</style>
